// src/common/contexts/LanguageContext.js
import React, { createContext, useState } from 'react';

// locale JSON 파일들은 common/locales 폴더에 위치합니다.
import ko   from '../locales/ko.json';
import en   from '../locales/en.json';
import ja   from '../locales/ja.json';
import es   from '../locales/es.json';
import fr   from '../locales/fr.json';
import id   from '../locales/id.json';
import pt   from '../locales/pt.json';
import ru   from '../locales/ru.json';
import tr   from '../locales/tr.json';
import de   from '../locales/de.json';
import zh   from '../locales/zh.json';
import zhTW from '../locales/zh-TW.json';

// 언어 코드 ↔ 번들 매핑
const bundles = {
  ko, en, ja, es, fr, id, pt, ru, tr, de, zh, 'zh-TW': zhTW,
};

// Context 기본값
export const LanguageContext = createContext({
  lang: 'en',
  setLang: () => {},
  t: (path) => bundles.en[path] || '',
});

export function LanguageProvider({ children }) {
  // 기본 언어를 English로 설정
  const [lang, setLang] = useState('en');

  // 번역 함수
  const t = (path) => {
    const bundle = bundles[lang] || bundles.en;
    return path
      .split('.')
      .reduce((obj, key) => (obj && obj[key] != null ? obj[key] : null), bundle);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}
